import { userAPI } from '@/services-ts/axios'
import type { IPayloadCompanySetting } from '@/types/Request'
import type { ILevelStore } from '@/types/Store/State'
import { defineStore } from 'pinia'
import {
  createSimpleListItem,
  deleteSimpleListItem,
  fetchSimpleList,
  updateSimpleListItem,
} from './simpleListHelpers'

export const useLevelStore = defineStore('level', {
  state: (): ILevelStore => ({
    levelList: [],
  }),

  actions: {
    async GetLevelList(): Promise<void> {
      const list = await fetchSimpleList(() => userAPI.LevelServices.GetLevelList())
      if (list) this.levelList = list
    },

    async CreateLevel(Name: string): Promise<boolean> {
      const item = await createSimpleListItem(name => userAPI.LevelServices.CreateLevel(name), Name)
      if (item) this.levelList.push(item)
      return !!item
    },

    async UpdateLevel(payload: IPayloadCompanySetting): Promise<boolean> {
      const status = await updateSimpleListItem(p => userAPI.LevelServices.UpdateLevel(p), payload)
      if (status) {
        this.levelList = this.levelList.map(level =>
          level.id === payload.Id
            ? { ...level, name: payload.Name, firstValue: payload.Name }
            : level,
        )
      }
      return status
    },

    async DeleteLevel(Id: string) {
      const status = await deleteSimpleListItem(id => userAPI.LevelServices.DeleteLevel(id), Id)
      if (status) {
        this.levelList = this.levelList.filter(level => level.id !== Id)
      }
    },
  },
})
